import * as React from 'react';
const Sliders = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-sliders", ...props },
    React.createElement("line", { x1: "4", y1: "21", x2: "4", y2: "14" }),
    React.createElement("line", { x1: "4", y1: "10", x2: "4", y2: "3" }),
    React.createElement("line", { x1: "12", y1: "21", x2: "12", y2: "12" }),
    React.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "3" }),
    React.createElement("line", { x1: "20", y1: "21", x2: "20", y2: "16" }),
    React.createElement("line", { x1: "20", y1: "12", x2: "20", y2: "3" }),
    React.createElement("line", { x1: "1", y1: "14", x2: "7", y2: "14" }),
    React.createElement("line", { x1: "9", y1: "8", x2: "15", y2: "8" }),
    React.createElement("line", { x1: "17", y1: "16", x2: "23", y2: "16" })));
export default Sliders;
//# sourceMappingURL=Sliders.js.map